/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { api } from "../api/httpClient";
import qs from "qs";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "@/utils/bindUrl";
import {
  IReason,
  IResponseListReason,
  IResponseShowReason,
} from "@/interfaces/reasons";

const BASE = "/reasons";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listReasons({
  filter,
  includes,
  page,
  limit,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListReason>(BASE, {
    params: { filter, includes, page, limit, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showReason({
  id,
  includes,
}: { id: string | number } & Partial<IListParams>) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowReason>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createReason({ reason }: { reason: IReason }) {
  const { data } = await api.post<IResponseShowReason>(BASE, { reason });
  return data;
}

export async function updateReason({
  id,
  reason,
}: {
  id: string | number;
  reason: IReason;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowReason>(url, { reason });
  return data;
}

// opcional
export async function deleteReason(id: string | number) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  await api.delete(url);
}
